module.exports = __webpack_public_path__ + "media/images/mv_img_about_pc-f23e7d32ec9046d9752ad3f950e42c62.png";